import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=01a36fd4"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=01a36fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports